export const useMicrositeStore = defineStore('micrositeStore', {
    state: () => ({
        microsite: {},
        navigation: [],
        globalTheme: '',
    }),
    getters: {
        loadedMicrosite(): boolean {
            return !isEmpty(this.microsite)
        },
        isMicrosite(): boolean {
            const { uri, microsites } = storeToRefs(useGlobalStore())

            return !!find(microsites.value, { uri: uri.value })
        },
    },
    actions: {
        initMicrosite(entry) {
            this.microsite = entry.__typename === 'ds_MicrositeHomepage_Entry' ? entry : get(entry, 'ancestors[0]', {})

            this.navigation = get(this.microsite, 'children', [])

            // set the theme
            const colorTheme = get(this.microsite, 'colorTheme', '')
            if (!isEmpty(colorTheme)) {
                this.globalTheme = colorTheme
            }
        },

    }
})
